import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';

export const useGetPurchaseOrders = (closedOrders: boolean, dateFrom: Date | null) => {
    const { data, isLoading } = useQuery({
        queryKey: ['purchase-orders', closedOrders, dateFrom],
        queryFn: async () => await apiClient.get(`purchase-order/orders`,
            {
                params: {
                    closedOrders: closedOrders,
                    dateFrom: dateFrom ? dateFrom.toISOString().substring(0, 10) : ''
                }
            }) as []
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
